import {DateTimePicker, LocalizationProvider} from "@mui/lab";
import {Button, CardHeader, Grid, Paper, Tab, Table, TableBody, TableCell, TableHead, TableRow, TextField} from "@mui/material";
import axios from "axios";
import * as React from "react";
import {Config} from "../../config/config";
import {Helpers} from "../../utils/helpers";
import {PopupMessage} from "../../utils/message";
import AdapterDateFns from "@mui/lab/AdapterDateFns";

export class RWBReport extends React.Component<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            startTime: new Date(),
            endTime: new Date(),
            loading: false,
            maps: []
        };
    }

    componentDidMount() {
        this.fetchData();
    }

    async fetchData() {
        const url = `${Config.getInstance.apiUrl}/api/ruby_wager_battle/map-names`;

        this.setState({
            loading: true,
        });

        const headers = {
            Authorization: Helpers.getSessionId(),
        }

        const response = await axios.get(url, {
            params: {
                startTime: this.state.startTime,
                endTime: this.state.endTime,
            },
            headers
        });

        const data = response.data;
        const success = data.success;

        this.setState({
            loading: false,
        });

        if (success) {
            const maps = data.maps;

            this.setState({
                maps,
            });
        } else {
            PopupMessage.error("Failed to fetch data")
        }

    }

    async getMapWithName() {
        const url = `${Config.getInstance.apiUrl}/api/ruby_wager_battle/map-with-name`;

        this.setState({
            loading: true,
        });

        const headers = {
            Authorization: Helpers.getSessionId(),
        }

        const response = await axios.get(url, {
            params: {
                startTime: this.state.startTime,
                endTime: this.state.endTime,
            },
            headers
        });

        const data = response.data;
        const success = data.success;

        this.setState({
            loading: false,
        });

        if (success) {
            const battles = data.battles;
            this.exportToCSV(battles);
        } else {
            PopupMessage.error("Failed to fetch data")
        }
    }

    exportToCSV(battles: any[]) {
        const {startTime, endTime} = this.state;

        // YYYY/MM/DD-HH:MM:SS
        const startStr = Helpers.formatDateWithTime(startTime, true);
        const endStr = Helpers.formatDateWithTime(endTime, true);

        const fileName = `map_with_name_${startStr}_${endStr}.csv`;
        let content = "data:text/csv;charset=utf-8,";

        content += `ID,Name`;

        for (const battle of battles) {
            content += `\n${battle.id},${battle.name}`;
        }

        const encodedUri = encodeURI(content);

        const link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", fileName);
        document.body.appendChild(link);

        link.click();
    }

    handleChangeTime = (key: string, value: any) => {
        this.setState({
            [key]: value,
        });
    }

    renderFilter() {
        return <Paper>
            <Grid container sm={12} rowSpacing={2}>
                <Grid item container sm={12}>
                    <Grid item container sm={4}>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DateTimePicker
                                label="Start Time"
                                value={this.state.startTime}
                                onChange={(e) => this.handleChangeTime("startTime", e)}
                                renderInput={(params) => <TextField {...params} size="small" />}
                                ampm={false}
                            />
                        </LocalizationProvider>
                    </Grid>

                </Grid>

                <Grid item container sm={12}>
                    <Grid item sm={4}>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DateTimePicker
                                label="End Time"
                                value={this.state.endTime}
                                onChange={(e) => this.handleChangeTime("endTime", e)}
                                renderInput={(params) => <TextField {...params} size="small" />}
                                ampm={false}
                            />
                        </LocalizationProvider>
                    </Grid>
                </Grid>

                <Grid item container sm={12} justifyContent={"flex-end"}>
                    <Grid item sm={1}>
                        <Button
                            color="primary"
                            onClick={this.getMapWithName.bind(this)}
                            variant="contained"
                        >
                            EXPORT
                        </Button>
                    </Grid>
                    <Grid item sm={1}>
                        <Button
                            color="primary"
                            onClick={this.fetchData.bind(this)}
                            variant="contained"
                        >
                            Search
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        </Paper>
    }

    renderContent() {
        const {maps} = this.state;

        return <Table>
            <TableHead>
                <TableRow>
                    <TableCell>#</TableCell>
                    <TableCell>Name</TableCell>
                    <TableCell>AVG Percent</TableCell>
                    <TableCell>AVG Star</TableCell>
                    <TableCell>Total Battles</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {
                    this.state.loading ?
                        <TableRow key="loading-row">
                            <TableCell colSpan={11}>
                                {Helpers.renderSkeletonRows(5, 50)}
                            </TableCell>
                        </TableRow>
                        :
                        maps.map((map: any, index: number) => {
                            return <TableRow key={index}>
                                <TableCell>{index + 1}</TableCell>
                                <TableCell>{map.name}</TableCell>
                                <TableCell>{`${map.avg_winner_percent}%`}</TableCell>
                                <TableCell>{map.avg_winner_star}</TableCell>
                                <TableCell>{Helpers.formatNumber(map.total_battles)}</TableCell>
                            </TableRow>
                        })
                }
            </TableBody>
        </Table>
    }

    render() {
        return <Paper className="contentPadding">
            <CardHeader title="RWB Report" />
            {this.renderFilter()}
            {this.renderContent()}
        </Paper>
    }
}